const theme = {
  colors: {
    primary: '#4DC8C4',  // 좀 더 밝고 부드러운 에메랄드
    secondary: '#FFB5B5', // 부드러운 코랄 핑크
    accent: '#FFE0A4', // 따뜻한 파스텔 옐로우
    text: '#4A5056',     // 부드러운 다크 그레이
    lightText: '#98A1AB', // 따뜻한 밝은 그레이
    background: '#FFFFFF',
    footer: '#F9FAFB',
    border: '#EDF0F2',
    hover: '#3DB9B5', // 호버시 살짝 진한 톤
    success: '#7ED48F', // 부드러운 그린
    error: '#FF9999',  // 부드러운 레드
    warning: '#FFD88A', // 부드러운 옐로우
    pastel: {
      mint: '#E5F7F6',    // 민트 파스텔
      pink: '#FFF0F0',    // 핑크 파스텔
      yellow: '#FFF8E7',  // 옐로우 파스텔
      blue: '#E9F3FF',    // 블루 파스텔
    }
  },
  fonts: {
    main: "'Noto Sans KR', sans-serif",
  },
  sizes: {
    maxWidth: '1400px',
    headerHeight: '80px',
    footerHeight: '200px',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
  },
  transitions: {
    standard: '0.3s ease-in-out',
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.06)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.08)',
    large: '0 8px 20px rgba(0, 0, 0, 0.1)',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem',
  },
  borderRadius: {
    small: '8px',
    medium: '12px',
    large: '20px',
    round: '50%',
  },
};

export default theme; 